import { client } from "./services/client";

export const marchands = {
  namespaced: true,
  state: {
    marchands: undefined,
    marchand: undefined,
    marchandInfo: undefined,
    marchandu: undefined,
    receiver_marchand: undefined,
  },
  mutations: {
    SET_MARCHANDS(state, marchands) {
      state.marchands = marchands;
    },
    SET_MARCHAND(state, marchand) {
      state.marchand = marchand;
    },
    SET_MARCHAND_USER(state, marchandu) {
      state.marchandu = marchandu;
    },
    SET_MARCHAND_INFO(state, marchandu) {
      state.marchandInfo = marchandu;
    },
    SET_RECEPTEUR(state, receiver_marchand) {
      state.receiver_marchand = receiver_marchand;
    },
  },
  actions: {
    getMarchand({ commit }) {
      return new Promise((resolve, reject) => {
        client({
          method: "get",
          url: "/marchands/get",
        })
          .then((response) => {
            let marchands = response.data.marchands;
            commit("SET_MARCHANDS", marchands);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getSettingReversmt({ commit }, data) {
      return new Promise((resolve, reject) => {
        client({
          method: "post",
          url: "/marchands/getSettingReversmt",
          data: data,
        })
          .then((response) => {
            let marchand = response.data.marchand;
            commit("SET_MARCHAND_INFO", marchand);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    setMarchand({ commit }, data) {
      return new Promise((resolve, reject) => {
        client({
          method: "post",
          url: "/marchands/save",
          data: data,
        })
          .then((response) => {
            let marchands = response.data.marchands;
            commit("SET_MARCHANDS", marchands);
            resolve(response.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    update({ commit }, data) {
      return new Promise((resolve, reject) => {
        client({
          method: "post",
          url: "/marchands/save",
          data: data,
        })
          .then((response) => {
            let marchands = response.data.marchands;
            commit("SET_MARCHANDS", marchands);
            sessionStorage.setItem(
              "marchand",
              JSON.stringify(response.data.marchand)
            );
            sessionStorage.setItem("keys", JSON.stringify(response.data.keys));
            resolve(response.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    filterMarchandsByCountry({ commit }, country) {
      return new Promise((resolve, reject) => {
        client({
          method: "get",
          url: "marchands/filter/by/country/" + country,
        })
          .then((response) => {
            commit("SET_MARCHANDS", response.data.marchands);
            resolve(response.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getRecepteur({ commit }, email) {
      return new Promise((resolve, reject) => {
        client({
          method: "get",
          url: "/transfers/get/recepteur/marchand/" + email,
        })
          .then((response) => {
            commit("SET_RECEPTEUR", response.data.receiver_marchand);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getmarchandDetails({ commit }, id) {
      return new Promise((resolve, reject) => {
        client({
          method: "get",
          url: "/marchand/detail/" + id,
        })
          .then((response) => {
            commit("SET_MARCHAND", response.data.marchand);
            resolve(response.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    rejet({ commit }, data) {
      return new Promise((resolve, reject) => {
        client({
          method: "get",
          url: "/marchand/rejet/" + data.id + "/" + data.reason,
        })
          .then((response) => {
            commit("SET_MARCHAND", response.data.marchand);
            resolve(response.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    validMarchand({ commit }, id) {
      return new Promise((resolve, reject) => {
        client({
          method: "get",
          url: "/marchands/valide/" + id,
        })
          .then((response) => {
            commit("SET_MARCHANDS", response.data.marchands);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    /* eslint-disable */
    mode({ commit }, id) {
      return new Promise((resolve, reject) => {
        client({
          method: "get",
          url: "/marchands/mode/" + id,
        })
          .then((response) => {
            sessionStorage.setItem(
              "marchand",
              JSON.stringify(response.data.marchand)
            );
            sessionStorage.setItem("keys", JSON.stringify(response.data.keys));
            resolve(response.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    etatMarchand({ commit }, data) {
      return new Promise((resolve, reject) => {
        client({
          method: "get",
          url: "/marchands/etat/" + data.id + "/" + data.state,
        })
          .then((response) => {
            let marchand = response.data.marchand;
            commit("SET_MARCHAND", marchand);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    changeMarchand({ commit }, id) {
      return new Promise((resolve, reject) => {
        client({
          method: "get",
          url: "/marchands/change/" + id,
        })
          .then((response) => {
            let marchand = response.data.marchand;
            commit("SET_MARCHAND", marchand);
            sessionStorage.setItem(
              "marchand",
              JSON.stringify(response.data.marchand)
            );
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getMarchandOne({ commit }) {
      return new Promise((resolve, reject) => {
        client({
          method: "get",
          url: "/marchands/get/one",
        })
          .then((response) => {
            let marchand = response.data.marchand;
            commit("SET_MARCHAND", marchand);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getMarchandUser({ commit }) {
      return new Promise((resolve, reject) => {
        client({
          method: "get",
          url: "/marchands/get/user",
        })
          .then((response) => {
            let marchandu = response.data.marchandu;
            commit("SET_MARCHAND_USER", marchandu);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getMarchandByUser({ commit }) {
      return new Promise((resolve, reject) => {
        client({
          method: "get",
          url: "/get/all/marchands/by/user",
        })
          .then((response) => {
            let marchandu = response.data.marchandu;
            commit("SET_MARCHANDS", marchandu);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    deleteMarchand({ commit }, id) {
      return new Promise((resolve, reject) => {
        client({
          method: "get",
          url: "/marchands/delete/" + id,
        })
          .then((response) => {
            let marchands = response.data.marchands;
            commit("SET_MARCHANDS", marchands);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    changesession({ commit }, id) {
      return new Promise((resolve, reject) => {
        client({
          method: "get",
          url: "/marchands/changesession/" + id,
        })
          .then((response) => {
            let marchands = response.data.marchands;
            commit("SET_MARCHANDS", marchands);
            sessionStorage.setItem(
              "marchand",
              JSON.stringify(response.data.marchand)
            );
            sessionStorage.setItem("keys", JSON.stringify(response.data.keys));
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
  },

  getters: {
    getMarchand: (state) => {
      return state.marchands;
    },
  },
};
